let accessToken = null;
let currentUser = null;
let refreshPromise = null;
const listeners = new Set();

const publish = () => listeners.forEach((listener) => listener({ accessToken, currentUser }));

export const getAccessToken = () => accessToken;
export const getCurrentUser = () => currentUser;
export const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const applyAuth = (auth) => {
  accessToken = auth.accessToken;
  currentUser = auth.user;
  localStorage.setItem("user", `${auth.user.firstName} ${auth.user.lastName}`);
  localStorage.setItem("userId", auth.user.id);
  publish();
  return auth;
};

const authRequest = async (path, options = {}) => {
  const response = await fetch(path, {
    ...options,
    credentials: "include",
    headers: { "Content-Type": "application/json", ...options.headers },
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `Authentication failed (${response.status})`);
  }
  return response.status === 204 ? null : response.json();
};

export const login = async (username, password) =>
  applyAuth(await authRequest("/api/auth/login", {
    method: "POST",
    body: JSON.stringify({ username, password }),
  }));

export const refreshSession = async () => {
  if (!refreshPromise) {
    refreshPromise = authRequest("/api/auth/refresh", { method: "POST" })
      .then(applyAuth)
      .catch((error) => {
        accessToken = null;
        currentUser = null;
        publish();
        throw error;
      })
      .finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
};

export const restoreSession = async () => {
  try {
    return applyAuth(await authRequest("/api/auth/session"));
  } catch (_) {
    accessToken = null;
    currentUser = null;
    publish();
    return null;
  }
};

export const logout = async () => {
  try {
    await authRequest("/api/auth/logout", { method: "POST" });
  } finally {
    accessToken = null;
    currentUser = null;
    localStorage.clear();
    publish();
  }
};
